import { Component, OnInit } from '@angular/core';
import { GlobalFunctionsService } from './../../services/global-functions.service';


@Component({
  selector: 'app-agent-users',
  templateUrl: './agent-users.component.html',
  styleUrls: ['./agent-users.component.css']
})
export class AgentUsersComponent implements OnInit {


  constructor(public gfunc: GlobalFunctionsService) {

  }

  ngOnInit() {
  }

}
